/**
 * 依赖收集 依赖触发 两个方法
 */

import {AnyObject} from 'src';
import {isNull} from 'src/utils/utils';

const effectStack: Function[] = [];
let activeEffect: any;

/**
 * 注册方法
 * @param fn
 * @param option
 */
export function effect(fn: Function, option: AnyObject = {}) {
  const effectFn = () => {
    try {
      effectStack.push(effectFn);
      activeEffect = effectFn;
      return fn();
    } finally {
      effectStack.pop();
      activeEffect = effectStack[effectStack.length - 1];
    }
  };

  //懒加载 并非第一次初始化
  if (!option.lazy) {
    effectFn();
  }

  //改方法上挂载调度
  effectFn.scheduler = option.scheduler;
  return effectFn;
}

/**
 * 依赖池
 */
const targetMap = new WeakMap();

/**
 * 收集依赖
 */
export function track(target: any, key: string) {
  //依赖不存在返回
  if (!activeEffect) return;

  let depsMap = targetMap.get(target);
  if (!depsMap) {
    targetMap.set(target, (depsMap = new Map())); //顺便赋值
  }

  let dep = depsMap.get(key);
  if (!dep) {
    depsMap.set(key, (dep = new Set())); //set防止重复收集依赖
  }

  dep.add(activeEffect);
}

/**
 * 触发依赖
 */
export function trigger(target: any, key: string) {
  const depsMap = targetMap.get(target);
  if (!depsMap) return;
  const dep = depsMap.get(key);
  if (!dep) return;
  dep.forEach((effectFn: any) => {
    if (effectFn.scheduler) {
      //有调度，采用调度器来执行effectFn
      effectFn.scheduler(effectFn);
    } else {
      effectFn();
    }
  });
}

/**
 * ban掉响应性
 * 先移除stack中引用，避免互相引用影响回收
 * weakmap 不可以遍历
 */
export function banEffect(fn: Function) {
  if (isNull(fn)) return;
  //删除stack指定元素
  const index = effectStack.indexOf(fn);
  if (index > -1) {
    effectStack.splice(index, 1);
    const length = effectStack.length;
    if (length > 0) {
      activeEffect = effectStack[effectStack.length - 1];
    }
  }
}
